import React from "react";
import termsBg from "./assets/uutoken.jpg"; 


const Privacy = () => {
  return (
    <>
      {/* TOP IMAGE HEADER */}
      <div
        className="terms-header-bg text-center d-flex flex-column justify-content-center pt-5 pb-4"
        style={{
          backgroundImage: `url(${termsBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h1 className="fw-bold mb-2 text-white">Privacy Policy</h1>
        <p className="text-white-50 mb-0 small">
          Governs use of Tokenly by Biswaas Enterprises
        </p>
      </div>

      {/* WHITE CARD BODY */}
      <div className="container pb-5" style={{ maxWidth: "900px" }}>
        <div className="terms-card mx-auto shadow rounded-4 p-4 p-md-5 bg-white">
          <p className="text-secondary mb-3">
            This Privacy Policy (“Privacy Policy”) governs your use of websites,
            mobile applications and technology operated by{" "}
            <strong>Biswaas Enterprises</strong>.
          </p>
          <p className="text-secondary mb-3">
            We, Biswaas Enterprises, would like Tokenly users to know that we
            will collect and use your personal information. The policies below
            are applicable to data and information collected when you use any of
            the following:
          </p>

          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                Biswaas Enterprises network of websites, including
                www.Tokenly.biswaas.com (including any versions optimized for
                viewing on a wireless or tablet device)
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                All email newsletters published or distributed by Biswaas
                Enterprises
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                All apps published by Biswaas Enterprises, including the
                “Tokenly” app
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                Any other services made available by Biswaas Enterprises
                (“Service”)
              </span>
            </li>
          </ul>

          <p className="text-secondary mt-3">
            All other interactive features and communications provided by
            Biswaas Enterprises (“App”), however accessed and/or used that are
            operated by us, made available by us, or produced and maintained by
            us, and our related companies (collectively “Tokenly” or “we”,
            “us”, or “our”).
          </p>
          <p className="text-secondary">
            We have established this privacy policy (“Privacy Policy”) to ensure
            that you understand what kinds of personal information we may gather
            during your use of this App, why we gather your information, how we
            use that information, when we might disclose your personal
            information, and how can you manage your personal information.
          </p>

          {/* Information Collection and Use */}
          <div className="section-title">
            <i className="fa-solid fa-database"></i> Information Collection and
            Use
          </div>
          <p className="text-secondary mb-3">
            We may request you to provide personally identifiable information
            for a better experience while using our Service. This may include
            but not be limited to location, name, and address. We collect two
            basic types of information from you: personal information; and
            non-personal information.
          </p>

          <h6 className="fw-bold text-dark mt-4 mb-2">Personal Information</h6>
          <p className="text-secondary small mb-2">
            The most common ways in which we may collect your personal
            information are listed below:
          </p>
          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                When you register for an account on the Tokenly App
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                When you use Tokenly App to refer to your friends
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                On submission of payment information for adding money to your
                Tokenly wallet and related communications, e.g. Aadhaar Number
                provided for KYC
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                Profile information (personal and non-personal) provided by you
                in the Tokenly App User Profile
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                When you participate in Tokenly ratings, surveys, or promotion
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                When you sign up to receive alerts or information via email,
                text or instant messages from Tokenly
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                When you request for assistance, customer service or support
              </span>
            </li>
          </ul>

          <h6 className="fw-bold text-dark mt-4 mb-2">
            Log Data &amp; Device Info
          </h6>
          <p className="text-secondary mb-3">
            When you use our Service and if there is an error in the App, we
            collect data and information (through third party products) on your
            phone, called Log Data. This may include IP address, device name,
            operating system version, app configuration, and time/date of use.
          </p>
          <p className="text-secondary">
            We might collect information about your use of the App, including
            GPS routes and status of GPS chips, and additional “traffic data”
            such as time of access, date of access, software crash reports,
            session identification number, access times, and referring App
            addresses.
          </p>

          <h6 className="fw-bold text-dark mt-4 mb-2">Children’s Privacy</h6>
          <p className="text-secondary">
            Our Services do not address anyone under the age of 13 years. We do
            not knowingly collect personal information from children under 13
            years. In the case we realize that a child under 13 years has
            provided us with personal information, we immediately delete this
            from our servers.
          </p>

          {/* Cookies */}
          <div className="section-title">
            <i className="fa-solid fa-cookie-bite"></i> Cookies
          </div>
          <p className="text-secondary mb-3">
            Cookies are files with small amount of data that is commonly used as
            anonymous unique identifier. These are sent to your browser from the
            website that you visit and are stored on your device internal
            memory.
          </p>
          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                We use cookies to remind us who you are and to find your account
                information in our database so you do not need to log in at
                every visit.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                We use cookies to determine the browser you use so the Apps can
                be designed to work efficiently.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                We use cookies to generate analytics regarding our App and
                determine user traffic.
              </span>
            </li>
          </ul>

          {/* How Do We Use Your Information? */}
          <div className="section-title">
            <i className="fa-solid fa-chart-line"></i> How Do We Use Your
            Information?
          </div>
          <p className="text-secondary mb-2">
            We use the information we receive from you to help us personalize
            services and improve your experience on the App. We may use your
            Personal and Non-Personal Information in the following ways:
          </p>
          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                To process your registration and provide the Tokenly Service to
                you at your request.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                To track the Tokenly App you use and upload your content at your
                request.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                To communicate with you about your account, transactions,
                policies, or comments.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                To personalize content, including providing reports,
                recommendations and feedback based on your preferences.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                To enhance or improve our products, services, operations, and
                perform statistical analyses.
              </span>
            </li>
          </ul>

          {/* With Whom is Your Information Shared? */}
          <div className="section-title">
            <i className="fa-solid fa-share-nodes"></i> With Whom is Your
            Information Shared?
          </div>
          <p className="text-secondary mb-3">
            Except as disclosed in this Privacy Policy, we do not disclose your
            Personal Information to any companies not part of Tokenly. In no
            event will we sell or rent your Personal Information as part of a
            customer list or similar transaction.
          </p>
          <p className="text-secondary mb-3">
            <strong>Third-Party Agents:</strong> We have third party agents,
            subsidiaries, affiliates and partners that perform functions on our
            behalf (hosting, billing, push notifications, etc.). These entities
            have access to your Personal Information needed to perform their
            functions and are contractually obligated to maintain
            confidentiality.
          </p>
          <p className="text-secondary">
            <strong>Emergency Situations:</strong> We may disclose Personal
            Information if required by law, or to protect our rights, property,
            or personal safety under emergency circumstances.
          </p>

          {/* Data Security & Transfer */}
          <div className="section-title">
            <i className="fa-solid fa-shield-halved"></i> Data Security &amp;
            Transfer
          </div>
          <p className="text-secondary mb-3">
            <strong>Transfer:</strong> Your information collected through the
            App may be stored and processed in India where Tokenly maintains
            facilities. By using the App you consent to the transfer of your
            information.
          </p>
          <p className="text-secondary">
            <strong>Security Steps:</strong> We practice great care in providing
            secure transmission of your information. Your Personal Information
            is stored in secure operating environments. However, transmission of
            data over the Internet cannot be guaranteed to be 100% secure.
          </p>

          {/* Governing Law */}
          <div className="section-title">
            <i className="fa-solid fa-gavel"></i> Governing Law
          </div>
          <p className="text-secondary">
            This App is published in India. Our App is located and targeted to
            Indian citizens and our policies are directed at compliance with
            those laws. If you are unsure whether the practices of this privacy
            policy are applicable to the local privacy laws where you are
            located, you should not submit your Personal Information to Tokenly.
          </p>

          {/* Your Choices & Opt-Out */}
          <div className="section-title">
            <i className="fa-solid fa-user-pen"></i> Your Choices &amp; Opt-Out
          </div>
          <p className="text-secondary mb-3">
            <strong>Collection:</strong> All personally identifiable information
            is provided on a voluntary basis. If you do not want Tokenly to
            collect such information, you should not submit it to the App
            (though this may limit functionality).
          </p>
          <p className="text-secondary mb-3">
            <strong>Emails:</strong> You may alter the preference of the type of
            communications you receive from us, including opting out of
            promotional communications, by updating the communication preferences
            in your account profile.
          </p>
          <p className="text-secondary mb-3">
            <strong>Tracking:</strong> You may choose to limit some tracking
            mechanisms on the App. You can choose to decline cookies, though
            certain features may not function properly.
          </p>
          <p className="text-secondary">
            <strong>Reviewing Information:</strong> You can review and change
            the information in your Tokenly account by logging into your account
            and editing your profile. We may not be able to delete your Personal
            Information without also deleting your user account.
          </p>

          {/* Return to home button */}
          <div className="text-center my-4 pt-3 border-top">
            <a
              href="/"
              className="btn btn-primary btn-lg d-inline-flex align-items-center shadow-sm"
            >
              <i className="fas fa-home me-2"></i>
              Return to Home Page
            </a>
          </div>

          {/* Contact box */}
          <div className="contact-box">
            <h5 className="fw-bold text-dark mb-3">Contact Us</h5>
            <p className="mb-1 text-muted">
              If you have any questions about this Privacy Policy, please
              contact us by email at:
            </p>
            <div className="d-flex justify-content-center mt-2">
              <a
                href="mailto:biswaasenterprises@gmail.com"
                className="text-decoration-none text-tokenly-primary fw-bold"
              >
                <i className="fa-solid fa-envelope me-1"></i>
                biswaasenterprises@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
